














































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { APIReport } from '@/models/api/report.model'
import { APIProduct } from '@/models/api/product.model'
import { FieldName } from '@/interfaces/field-name.interface'
import { APIPagination } from '@/models/api/pagination.model'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import moment from 'moment'
import { APIProvider } from '@/models/api/provider.model'
import { APIUser } from '@/models/api/user.model'
import { APIRole } from '@/models/api/role.model'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class ReportAgend extends Vue {
    loading = false
    mainTitle = ''
    reportData: APIReport
    chartEnabled = false
    buttonLoading = false

    providersList: APIProvider[] = []
    productChilds: object[] = []
    nameProductChilds: object[] = []

    products: object[] = []
    nameProducts: object[] = []
    providers: object[] = []
    agendPeriodicities: object[] = []
    reportAgends: object[] = []
    recipientUsers: number[] = []
    recipientEmails: string[] = []
    usersList: object[] = []

    reportFilters: FieldName[] = []

    filterRangeDate = false

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        onlyNumbers: [
            (v: string) => !!v || 'This field is required',
            (v: string) => {
                const pattern = /^[0-9]*$/
                return pattern.test(v) || 'This field accept only numbers'
            }
        ],
        emails: [
            (v: string[]) => {
                if (!v || v.length === 0) return true
                const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                return v.every(email => pattern.test(email)) || 'Some emails are not valid'
            }
        ]
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: {[key: string]: any} = {
        typeId: {
            id: null
        }
    }

    min = -30
    max = 0
    range = [-1, 0]

    dinamicDates = false
    now = moment().format('YYYY-MM-DD').toString()
    showTable = false
    selectRows = false
    rowsPerPage = 15
    selectedRows = []
    pagination: APIPagination = {
        currentPage: 1,
        total: 0,
        nextPage: null,
        previousPage: null
    }

    customColums: ADMColumn[] = []
    colNames: ADMColumn[] = [
        { text: 'Id', value: 'agendId' },
        { text: 'Subject', value: 'agendSubject' },
        { text: 'Periodicity', value: 'agendPeriodicityId.periodicity' },
        { text: 'Time', value: 'agendTime' },
        { text: 'Recipients', value: 'recipients' },
        {
            text: 'Actions',
            width: '100px',
            value: 'actions',
            customField: {
                type: 'options',
                hideAll: false
            }
        }
    ]

    confirmDialogTrigger = false
    confirmDialogClone = false
    confirmDialogData = null
    editingAgendId: number | null = null

    changeRange (minValue: number, maxValue: number) {
        this.range = [minValue, maxValue]
    }

    changeFilterRangeDate () {
        return this.reportFilters.map((item) => {
            if (item.queryValue === '[from]') {
                item.paramValue = this.range[0].toString()
                item.dinamicDate = true
            }
            if (item.queryValue === '[to]') {
                item.paramValue = this.range[1].toString()
                item.dinamicDate = true
            }
            if (item.queryValue === '[date_created]') {
                item.paramValue = this.range[0].toString()
                item.dinamicDate = true
            }
            return item
        })
    }

    showFilterRangeDate (filterName: string) {
        if (this.dinamicDates && (filterName === '[from]' || filterName === '[to]' || filterName === '[date_created]')) {
            return false
        } else {
            return true
        }
    }

    validFilterRangeDate () {
        const dates = this.reportFilters.filter(x => x.queryValue === '[from]' || x.queryValue === '[to]' || x.queryValue === '[date_created]')
        if (dates.length > 0) {
            this.filterRangeDate = true
        } else {
            this.filterRangeDate = false
        }
    }

    confirmedDialog (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('deleteReporAgends', callback.agendId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.getAgends()
                }
            })
    }

    closePicker (v: number) {
        const value = v < 10 ? '0' + v : v
        this.formData.agendTime = value + ':00'
        this.formData.agendTimeMenu = false
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    get isAdmin () {
        return this.userData.roles?.some((role: APIRole) => {
            const roleName = role.roleName?.toLowerCase()
            return Number(role.roleId) === 1 || roleName === 'administrator' || roleName === 'admin'
        })
    }

    get tableHeaders () {
        const columns = [...this.colNames]
        if (this.isAdmin && !columns.find(column => column.value === 'owner')) {
            columns.splice(1, 0, { text: 'Owner', value: 'owner' })
        }
        return columns
    }

    getData () {
        this.loading = true
        if (!this.$route.params.reportId) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getReportsById', this.$route.params.reportId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.reportData = this.$store.state.ReportsStore.reportForm
                    this.mainTitle = this.reportData.reportName
                    this.loading = false
                    if (this.reportData.reportChartEnabled) {
                        this.chartEnabled = true
                    }
                }
            })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getProductsByProvider (filter: any, existChild: boolean) {
        return new Promise(resolve => {
            const provider = this.providersList.find(x => x.providerId === filter.paramValue)
            if (provider && existChild) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const carrierId: any = provider?.carrierId
                this.$store.dispatch('getMonitorProductsFilter', { carrierId: carrierId.carrierId, providerId: provider?.providerId })
                    .then(resp => {
                        if (resp.status === 200) {
                            this.productChilds = resp.data.map((p: APIProduct) => {
                                return {
                                    text: p.productName,
                                    value: p.productId
                                }
                            })
                            this.nameProductChilds = resp.data.map((p: APIProduct) => {
                                return {
                                    text: p.productName,
                                    value: p.productName
                                }
                            })
                            resolve()
                        }
                    })
            }
        })
    }

    getProducts () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorProductsFilter', {})
                .then(resp => {
                    if (resp.status === 200) {
                        this.products = this.$store.state?.ProductsStore?.products?.map((p: APIProduct) => {
                            return {
                                text: p.productName,
                                value: p.productId
                            }
                        })
                        this.nameProducts = this.$store.state?.ProductsStore?.products?.map((p: APIProduct) => {
                            return {
                                text: p.productName,
                                value: p.productName
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getProviders () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorProvidersFilter', { carrierId: this.userData.carrierId?.carrierId })
                .then(resp => {
                    if (resp.status === 200) {
                        const provider = this.$store.state.AuthStore.auth.user.providerId
                        if (provider && provider.providerId) {
                            provider.carrierId = this.$store.state.AuthStore.auth.user.carrierId
                            this.providersList = [provider]
                            this.providersList.forEach((provider: {providerId: number; providerName: string}) => {
                                this.providers.push({
                                    text: provider.providerName,
                                    value: provider.providerId
                                })
                            })
                        } else {
                            this.providersList = resp.data
                            resp.data.forEach((provider: {providerId: number; providerName: string}) => {
                                this.providers.push({
                                    text: provider.providerName,
                                    value: provider.providerId
                                })
                            })
                        }

                        resolve()
                    }
                })
        })
    }

    getPeriodicities () {
        return new Promise(resolve => {
            this.$store.dispatch('getReportAgendPeriodicities')
                .then(resp => {
                    if (resp.status === 200) {
                        resp.data.forEach((periodicities: {agendPeriodicityId: number; periodicity: string}) => {
                            this.agendPeriodicities.push({
                                text: periodicities.periodicity,
                                value: periodicities.agendPeriodicityId
                            })
                        })
                        resolve()
                    }
                })
        })
    }

    existFilter (filterName: string) {
        const filter = this.reportFilters.filter(x => x.realValue === filterName)
        return filter.length > 0
    }

    getFilters () {
        this.loading = true
        this.$store.dispatch('getReportFilters', this.$route.params.reportId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.reportFilters = resp.data
                    this.validFilterRangeDate()
                }
                this.loading = false
            })
    }

    getAgends () {
        this.loading = true
        this.$store.dispatch('getReportAgends', { userId: this.$store.state.AuthStore.auth.user.userId, reportId: this.$route.params.reportId })
            .then(resp => {
                if (resp?.status === 200) {
                    this.reportAgends = resp.data
                }
                this.loading = false
                this.showTable = true
            })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getOwnerName (item: any) {
        if (!item.userId) return ''
        const owner = item.userId
        return `${owner.username}`
    }

    getUsersFilter () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getUsersFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        const userLogued = this.$store.state.AuthStore.auth.user.userId
                        this.usersList = resp.data
                            .filter((user: APIUser) => user.userId !== userLogued)
                            .map((user: APIUser) => {
                                return {
                                    ...user,
                                    text: `${user.username}${user.email ? ' - ' + user.email : ''}`,
                                    disabled: !user.email
                                }
                            })
                        resolve()
                    }
                })
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getAgendPeriodicityValue (item: any) {
        if (typeof item.agendPeriodicityId === 'object') {
            return item.agendPeriodicityId?.agendPeriodicityId
        }
        return item.agendPeriodicityId
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseAgendFilters (item: any): FieldName[] {
        if (!item.agendDataReport) return []
        try {
            const filters = JSON.parse(item.agendDataReport)
            return Array.isArray(filters) ? filters : []
        } catch (error) {
            this.$store.commit('reportError', { code: 1000, message: 'Error parsing scheduled report filters :(' })
            return []
        }
    }

    parseRecipients<T> (value?: string): T[] {
        if (!value) return []
        try {
            const parsed = JSON.parse(value)
            return Array.isArray(parsed) ? parsed : []
        } catch (error) {
            this.$store.commit('reportError', { code: 1000, message: 'Error parsing scheduled report recipients :(' })
            return []
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getRecipientsCount (item: any) {
        const users = this.parseRecipients<number>(item.agendUserRecipients)
        const emails = this.parseRecipients<string>(item.agendEmailRecipients)
        return `${users.length} users / ${emails.length} emails`
    }

    setDinamicRangeFromFilters () {
        this.dinamicDates = this.reportFilters.some(filter => filter.dinamicDate)
        if (!this.dinamicDates) {
            this.range = [-1, 0]
            return
        }

        const fromFilter = this.reportFilters.find(filter => filter.queryValue === '[from]' || filter.queryValue === '[date_created]')
        const toFilter = this.reportFilters.find(filter => filter.queryValue === '[to]')
        this.range = [
            fromFilter ? parseInt(fromFilter.paramValue) : -1,
            toFilter ? parseInt(toFilter.paramValue) : 0
        ]
    }

    loadProviderChildrenFromFilters () {
        const providerFilter = this.reportFilters.find(filter => filter.realValue === 'Provider')
        if (providerFilter) {
            this.getProductsByProvider(providerFilter, this.existFilter('Product'))
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    startEdit (item: any) {
        const filters = this.parseAgendFilters(item)
        this.editingAgendId = item.agendId
        this.formData = {
            ...this.formData,
            agendSubject: item.agendSubject,
            agendPeriodicityId: this.getAgendPeriodicityValue(item),
            agendTime: item.agendTime
        }
        this.recipientUsers = this.parseRecipients<number>(item.agendUserRecipients)
        this.recipientEmails = this.parseRecipients<string>(item.agendEmailRecipients)
        if (filters.length > 0) {
            this.reportFilters = filters
        }
        this.setDinamicRangeFromFilters()
        this.validFilterRangeDate()
        this.loadProviderChildrenFromFilters()
    }

    resetFormState () {
        this.editingAgendId = null
        this.dinamicDates = false
        this.range = [-1, 0]
        this.formData = {
            typeId: {
                id: null
            }
        }
        this.recipientUsers = []
        this.recipientEmails = []
        this.reportFilters = this.reportFilters.map(item => ({
            ...item,
            paramValue: '',
            calendar: false,
            dinamicDate: false
        }))
        this.getFilters()
        if (this.$refs.form) {
            (this.$refs.form as Vue & { resetValidation: () => boolean }).resetValidation()
        }
    }

    cancelEdit () {
        this.resetFormState()
    }

    buildAgendPayload () {
        const filter = this.dinamicDates ? this.changeFilterRangeDate() : this.reportFilters

        return {
            agendId: this.editingAgendId || undefined,
            reportId: parseInt(this.$route.params.reportId),
            userId: this.$store.state.AuthStore.auth.user.userId,
            agendPeriodicityId: this.formData.agendPeriodicityId,
            agendTime: this.formData.agendTime,
            agendSubject: this.formData.agendSubject,
            agendDataReport: JSON.stringify(filter),
            agendUserRecipients: JSON.stringify(this.recipientUsers),
            agendEmailRecipients: JSON.stringify(this.recipientEmails),
            agendEnabled: 1
        }
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        const dataSend = this.buildAgendPayload()
        const action = this.editingAgendId ? 'editAgends' : 'createAgends'

        this.$store.dispatch(action, dataSend)
            .then(resp => {
                this.buttonLoading = false

                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.resetFormState()
                    this.getAgends()
                }
            })
    }

    async mounted () {
        this.getData()
        this.getFilters()
        this.getPeriodicities()
        this.getAgends()
        this.getProviders()
        this.getProducts()
        this.getUsersFilter()
        this.colNames.forEach(column => {
            if (column.customField) this.customColums.push(column)
        })
    }
}
